export const getLoginFormErrorLabel = (code: string | null) => {
    if (!code) return '';

    switch (code) {
        case 'email_not_found':
            return 'Не нашли такую почту. Если вы всё верно написали, обратитесь в HelpDesk';
        case 'password_changed':
        case 'user_blocked':
            return '';
        default:
            return 'Что-то пошло не так — попробуйте снова';
    }
};
